// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags_tags__uTP1I"};